import { createAction } from "@ngrx/store";
import { ActionModel, FindingDetails } from "../models/assesment.model";

export const ADD_FINDING = createAction(
  "ADD_FINDING",
  (finding: FindingDetails) => finding,
);

export const UPDATE_FINDING = createAction(
  "UPDATE_ASSESMENT",
  (finding: FindingDetails) => ({ finding }),
);

export const ADD_FINDINGS = createAction(
  "ADD_FINDINGS",
  (findings: FindingDetails[]) => ({
    findings,
  }),
);

export const UPDATE_FINDINGS = createAction(
  "UPDATE_FINDINGS",
  (finding: FindingDetails) => ({ finding }),
);

export const ADD_ACTION = createAction(
  "ADD_ACTION",
  (action: ActionModel) => action,
);

export const UPDATE_ACTION = createAction(
  "UPDATE_ACTION",
  (action: ActionModel) => ({ action }),
);

export const ADD_ACTIONS = createAction(
  "ADD_ACTIONS",
  (actions: ActionModel[]) => ({
    actions,
  }),
);

export const UPDATE_ACTIONS = createAction(
  "UPDATE_ACTIONS",
  (action: ActionModel) => ({ action }),
);
